import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import FixedSection from "../../Components/FixedSection";
import { useParams } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { api } from "methods/api";
import Spinner from "pages/SpinnerPage/Spinner";
import { imgPath } from "methods/img";
import { HotelCardType } from "types/Hotel";
import { homeContext } from "pages/HomeContext";
import RenderRte from "Components/RenderRte";
import { LocalNavLink } from "hooks/useLocalNavigate";

function HotelCard() {
  const [t] = useTranslation();
  const { id } = useParams();
  const [status, setStatus] = useState<"none" | "loading" | "done">("none");
  const [products, setProducts] = useState<HotelCardType | undefined>(
    undefined
  );
  const { homeData } = useContext(homeContext);

  function getProductsData() {
    setStatus("loading");
    axios
      .get<{ data: HotelCardType }>(api(`hotels/${id}`))
      .then(({ data }) => {
        setStatus("done");
        setProducts(data.data);
      })
      .catch((error) => {
        console.log("error", error);
        setStatus("none");
      });
  }

  useEffect(() => {
    getProductsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <>
      {status == "done" ? (
        <>
          <FixedSection title={homeData?.siteInformation?.hotel_title} />
          <Stack sx={{ padding: "80px 30px" }}>
            <Typography
              variant="h3"
              sx={{ textAlign: "center", fontWeight: 600, mb: 10 }}
            >
              {products?.department}
            </Typography>
            <Container>
              <Grid container spacing={2}>
                {products?.hotels?.map((card, index) => (
                  <Grid item md={4} key={card.id ?? index}>
                    <Card
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        backgroundColor: "#fff",
                        minHeight: "400px",
                        border: "2px solid",
                        borderRadius: "10px",
                        overflow: "hidden",
                        "&:hover .line": { width: 1 },
                      }}
                    >
                      <Box
                        component={LocalNavLink}
                        to={`/product/${card.id}`}
                        sx={{
                          overflow: "hidden",
                          height: "250px",
                          display: "block",
                          "&:hover img": { transform: "scale(1.1)" },
                        }}
                      >
                        <img
                          src={imgPath(card?.metaImage?.[0]?.image)}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            transition: "all .5s",
                            display: "block",
                          }}
                          alt={card.title ?? ""}
                        />
                      </Box>

                      <CardContent>
                        <Typography
                          variant="h6"
                          component={LocalNavLink}
                          to={`/product/${card.id}`}
                          sx={{
                            fontWeight: 700,
                            marginY: 0.5,
                            display: "inline-block",
                          }}
                        >
                          {card.title}
                        </Typography>

                        <Box
                          color={"#F19B02"}
                          sx={{ borderBottom: "dashed 1px #000", pb: 2 }}
                        >
                          <StarIcon />
                          <StarIcon />
                          <StarIcon />
                          <StarIcon />
                          <StarIcon />
                        </Box>

                        {/* لو الحقل مش description غيّره حسب الـ API */}
                        {(card as any).description && (
                          <Typography variant="body1" sx={{ py: 2 }}>
                            <RenderRte
                              rte={(card as any).description}
                              more={true}
                            />
                          </Typography>
                        )}

                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Typography
                            variant="body1"
                            component={LocalNavLink}
                            to={`/product/${card.id}`}
                            sx={{
                              borderRadius: "10px",
                              backgroundColor: homeData?.SiteColor.mainColor,
                              transition: "all .3s",
                              color: "#fff",
                              padding: "9px",
                            }}
                          >
                            {t("main.ReadMore")}
                          </Typography>
                        </Box>
                      </CardContent>

                      <Box
                        sx={{
                          width: 0,
                          height: "5px",
                          backgroundColor: "primary.main",
                          transition: "all .8s",
                        }}
                        className={"line"}
                      ></Box>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Container>
          </Stack>
        </>
      ) : (
        <Spinner />
      )}
    </>
  );
}

export default HotelCard;